export const efaPersonalDetails = {
  efaPersonalDetails: {
    infoMsg: 'Sie haben Änderungswünsche zu Ihren persönlichen Details? Kontaktieren Sie bitte unseren Kundenservice',
  }
};
